import { TextField } from 'src/components/Form/TextField';
import { Title } from 'src/components/ui/Title';
import { SelectDateFieldBirthdate } from '../Form/SelectDateFieldBirthdate';

type LegalEntityDataFormProps = {
  creatingOrder: boolean;
};

const LegalEntityDataForm = ({ creatingOrder }: LegalEntityDataFormProps) => {
  return (
    <div className="mt-4 grid grid-flow-row grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
      <div className="col-span-2">
        <TextField
          name="customerCompanyDocument"
          label="CNPJ"
          mask="cnpj"
          autoComplete="customerCompanyDocument"
          type="tel"
          isRequired
        />
      </div>

      <div className="col-span-2">
        <TextField
          name="customerCompanyName"
          label="Razão social"
          autoComplete="customerCompanyName"
          isRequired
        />
      </div>

      <div className="col-span-2">
        <TextField
          name="email"
          label="E-mail de cobrança"
          type="email"
          autoComplete="email"
          isRequired
        />
      </div>

      <Title
        size="sm"
        className="col-span-2 mt-4"
      >
        Dados do responsável legal
      </Title>

      <div className="col-span-2">
        <TextField
          name="name"
          label="Nome completo"
          autoComplete="name"
          isRequired
          isDisabled={!creatingOrder}
        />
      </div>

      <div className="col-span-2">
        <TextField
          name="phone"
          label="Celular com DDD"
          placeholder="DDD + Número"
          type="tel"
          mask="phone"
          isRequired
        />
      </div>

      <div className="col-span-2 sm:col-span-1">
        <TextField
          name="cpf"
          label="CPF"
          placeholder="Apenas números"
          type="tel"
          mask="cpf"
          isDisabled={!creatingOrder}
          isRequired
        />
      </div>

      <div className="col-span-2 sm:col-span-1">
        <SelectDateFieldBirthdate
          name="birthdate"
          label="Data de nascimento"
          isDisabled={!creatingOrder}
        />
      </div>
    </div>
  );
};

export { LegalEntityDataForm };
